import { ActionType, createAction } from "typesafe-actions";

import UserLogin from "@mapmycustomers/shared/types/userLogin/UserLogin";

export const fetchSessions = createAction("settings/sessions/fetchSessions")<{
  callback: (userLogins: UserLogin[]) => void;
  failureCallback?: () => void;
}>();

export const logoutOtherSessions = createAction("settings/sessions/logoutOtherSessions")<{
  callback: () => void;
  failureCallback: () => void;
}>();

export const logoutSession = createAction("settings/sessions/logoutSession")<{
  callback: () => void;
  failureCallback: () => void;
  id: UserLogin["id"];
}>();

export type Actions = ActionType<
  typeof fetchSessions | typeof logoutOtherSessions | typeof logoutSession
>;
